<template>
  <all-emails></all-emails>
</template>

<script>
import AllEmails from "../components/Email/Emails.vue";

export default {
  name: "EmailsView",
  components: {
    AllEmails,
  },
};
</script>
